import React, { useState } from 'react';
import agentPageStore from '../store';
import { observer } from 'mobx-react-lite';
import { Dropdown } from 'antd';
import IconButton from '@/components/chat-history/IconButton';
import { HelperCore, HelpOther } from '@/common/helper';
import globalStore from '@/store/global';
import CreateWcpModal from '@/components/modal/create-wcp';
import copy from 'copy-to-clipboard';
import Other from '@/common/helper/other';
import { getAgentFlowId, McpAgentType } from '@shared/constants/mcp';
import client from '@/store/client';

const dropList = (item, deleteCallback, setShowDropdown) => {
  return (
    <div
      className={`w-[150px] px-[8px] py-[8px] rounded-[12px] flex flex-col ${globalStore.isDark ? 'bg-[#31313A]' : 'bg-white'}`}
      style={{
        boxShadow: '0px 2px 8px 0px #0000001A',
        border: '1px solid rgba(0,0,0,0.1)',
      }}
    >
      {item?.agent_type != 4 ? (
        <div
          className={`w-full h-[40px] rounded-[8px] font-bold text-[14px] text-[#000] flex items-center cursor-pointer hover:bg-[#000] hover:bg-opacity-4 ${globalStore.isDark ? 'bg-[#31313A]' : 'bg-white'}`}
          onClick={() => {
            setShowDropdown(false);
            // 工作流
            if(item.agent_type == McpAgentType.flow){
              client.openPage(`${import.meta.env.VITE_FLOW_HOST}/flowDetailV3?${HelperCore.param({
                id : item.flow_id,
                teamId : item.team_id || '',
                flow_type : 1,
              })}`);
            }
            // 智能体
            else {
              globalStore.navigate(`/tools/aiagent/manage?id=${item.id}`);
            }
          }}
        >
          <IconButton
            className="!hover:bg-transparent"
            icon="edit"
            size={20}
          ></IconButton>
          编辑
        </div>
      ) : null}
      <div
        className={`w-full h-[40px] rounded-[8px] font-bold text-[14px] text-[#FF3B30] flex items-center cursor-pointer hover:bg-[#FEF5F6] ${globalStore.isDark ? 'bg-[#31313A]' : 'bg-white'}`}
        onClick={() => {
          setShowDropdown(false);
          HelpOther.confirm({
            title: '删除智能体',
            okText: '删除',
            content: (
              <div className="whitespace-nowrap">确定要删除该智能体吗？</div>
            ),
            onOk: () => {
              // 工作流
              if(item.agent_type == McpAgentType.flow){
                agentPageStore.deleteFlowAgent(item, deleteCallback);
              } 
              // 智能体
              else {
                agentPageStore.deleteAgent(item.id, item.agent_type, deleteCallback);
              }
            },
          });
        }}
      >
        <IconButton
          className="!hover:bg-transparent"
          icon="icon_delete_dropdown"
          size={20}
        ></IconButton>
        删除智能体
      </div>
    </div>
  );
};

const AagentMenu = observer(
  ({ item, scene = 'my', className, deleteCallback }) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const isMine = scene == 'my';

    if (!item) return null;
    return (
      <div
        onClick={evt => {
          evt.stopPropagation();
        }}
        className={[
          className,
          isMine ? (showDropdown ? 'block' : 'hidden') : '',
        ]}
      >
        <Dropdown
          dropdownRender={() => dropList(item, deleteCallback, setShowDropdown)}
          trigger="click"
          placement="topRight"
          open={showDropdown}
          onOpenChange={visible => {
            setShowDropdown(visible);
          }}
        >
          {isMine ? (
            <IconButton
              className={[
                '!hover:bg-[rgba(0,0,0,0.06)] bg-[rgba(0,0,0,0.03)] !p-0',
                showDropdown ? 'bg-[rgba(0,0,0,0.06)]' : '',
              ]}
              iconClassName="text-[rgb(0,0,0,.7)] px-8px"
              icon="more_v2"
              size={28}
            />
          ) : (
            <IconButton
              className={['!hover:bg-[rgba(0,0,0,0.03)] !p-0 !rounded-full']}
              iconClassName="text-[rgb(0,0,0,.7)] px-8px"
              icon="more_v2"
              size={32}
            />
          )}
        </Dropdown>
      </div>
    );
  }
);

export default AagentMenu;
